import React from "react";
import { toCamelCase } from "@bandit-network/utils";
import { FaCircleCheck } from "react-icons/fa6";

interface QuestCardProps {
  name: string;
  chain: string;
  participants: number;
  rewards: any;
  source: string;
  profilePic: string;
  spaceProfilePic: string;
  spaceName: string;
  onClick: () => void;
  hasUserClaimed: boolean;
}

const QuestCard = ({
  name,
  chain,
  participants,
  rewards,
  source,
  profilePic,
  onClick,
  spaceProfilePic,
  spaceName,
  hasUserClaimed,
}: QuestCardProps) => {
  return (
    <div className="bad-quest_card" onClick={onClick}>
      {hasUserClaimed && (
        <div className="bad-quest_card-is-claimed">
          <FaCircleCheck className="bad-quest_card-is-claimed-icon" />
        </div>
      )}
      <div className="bad-quest_card__content">
        <div className="bad-quest_card__space">
          <div className="bad-quest_card__space--image-container">
            <img
              src={spaceProfilePic}
              alt="space name"
              className="bad-quest_card__space--image"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src =
                  "https://imagedelivery.net/6iczWBYEbx_1dYNU7ek_bA/443e638a-329e-4051-0913-92c8ebc7a700/medium";
              }}
            />
          </div>
          <div className="bad-quest_card__space--name">
            {toCamelCase(spaceName)}
          </div>
        </div>
        <h3 className="bad-quest_card--title">{name}</h3>
        <div className="bad-quest_card--reward">
          <div className="bad-quest_card__reward--participants">
            {participants > 0
              ? [...Array(participants > 3 ? 3 : participants).keys()].map(
                  (index) => (
                    <div
                      key={index}
                      className={
                        index === 0
                          ? "bad-quest_card__participants-1"
                          : "bad-quest_card__participants"
                      }
                    >
                      <img
                        src={`https://source.boringavatars.com/marble/120/${
                          participants + index
                        }?colors=1B325F,9CC4E4,E9F2F9,3A89C9,3A89C9`}
                        alt="participants"
                        className="bad-quest_card__participants--image"
                      />
                    </div>
                  ),
                )
              : null}
            {participants > 3 && (
              <div className="bad-quest_card__participants--count">
                <span className="bad-quest_card__participants--count-number">
                  +
                  {Intl.NumberFormat("en", {
                    notation: "compact",
                  }).format(participants)}
                </span>{" "}
                Participants
              </div>
            )}
          </div>

          <div className="bad-quest_card__reward--type">
            <img
              className="bad-quest_card__reward--chain"
              src={`https://assets.bandit.network/networks/${chain.toLocaleLowerCase()}.svg`}
              alt="blockchain"
            />
            <span className="bad-quest_card__reward--type-text">{rewards}</span>
          </div>
        </div>
        {!!profilePic && (
          <div className="bad-quest_card__image-wrapper">
            <img
              src={profilePic}
              alt="Quest image"
              className="bad-quest_card__image"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src =
                  "https://imagedelivery.net/6iczWBYEbx_1dYNU7ek_bA/443e638a-329e-4051-0913-92c8ebc7a700/medium";
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestCard;
